<template>
  <div class="animated fadeIn">
    <b-card no-body class="mt-1 mb-1">
      <div v-if="formatted_rows.length" class="py-3 px-4">
        <b-row class="pr-3">
          <b-col
            v-for="(row, rowIndex) in formatted_rows"
            :key="rowIndex"
            sm="12"
            md="6"
            class="pr-0"
          >
            <b-row class="pr-3">
              <b-col v-if="row.label" class="pr-0">
                <label class="font-weight-bold">
                  {{ row.label }}
                </label>
              </b-col>
              <b-col class="pr-0">
                <span>{{ row.value }}</span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import CustomerModel from '@/models/crm/CustomerModel'

export default {
  name: 'CustomerCard',
  props: {
    customer: {
      type: Object,
      default: () => new CustomerModel()
    }
  },
  computed: {
    header () {
      const { first_name, last_name } = this.customer
      return first_name || last_name ? `${first_name} ${last_name || ''}` : 'TBD'
    },

    icon () {
      return this.customer.icon()
    },

    rows () {
      const { short_name, account_number } = this.customer
      return [
        {
          label: 'Short Name',
          value: short_name || 'TBD'
        },
        {
          label: 'Account #',
          value: account_number || 'TBD'
        }
      ]
    },

    formatted_rows () {
      const rows = []

      for (let i = 0; i < this.rows.length; i++) {
        if (this.rows[i].value) {
          const row = this.rows[i]

          !row.slot &&
            (row.slot = row.label ? row.label.replace(/\s+/g, '') : `row-${i}`)
          rows.push(row)
        }
      }

      return rows
    }
  }
}
</script>
